import { ChangeDetectionStrategy, Component, effect, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchFieldComponent } from '@modules/components/search-field/search-field.component';
import { ReferenceFilter } from '@modules/filter/directives/reference-filter.directive';
import { provideFilterItem } from '@modules/filter/utils/token';
import { FilterBean, FilterType } from '@type/filter.type';
import { NamedId } from '@type/name-id.type';

const DEFAULT_FILTER = new FilterBean(FilterType.Select);

@Component({
  selector: 'app-f-select',
  imports: [SearchFieldComponent, MatCheckboxModule, FormsModule],
  providers: [provideFilterItem(FSelectComponent)],
  templateUrl: './f-select.component.html',
  styleUrl: './f-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FSelectComponent extends ReferenceFilter<FilterBean> {
  #setDictionary = async () => {
    const { dict, total } = await this.fds.getSelectDictionary(this.row().dictionaryModel);
    this.count.set(total);
    this.dictionary.set(dict);
  };

  #ee = effect(this.#setDictionary);

  dictionary = signal<NamedId[]>([]);

  count = signal(0);

  defaultFilter(): FilterBean {
    return { ...DEFAULT_FILTER, value: [], name: this.filter?.name || '', model: this.filter?.model || '' };
  }
}
